module.exports = __webpack_public_path__ + "static/media/Montserrat-MediumItalic.5c7f9907.ttf";